export default __webpack_public_path__ + "static/force-usa_small-image_2-4e678eded5f3f4eff56c4e315db54389.webp";